/*
 * This page is currently commented out of the sidebar nav
 * src/pages/evaluations/Sidebar/pageNavigationLinks.js
 */
import React from 'react';
import ParentLayout from '@/pages/evaluations-event-partners-filtered/Layout';
import useRouter from '@/hooks/useRouter';
import useQuery from './useQuery';
import Evaluation from './Evaluation';
import useSchoolYearParams from '@/pages/evaluations/useSchoolYearParams';
import queryString from 'query-string';

export default function Layout() {
  const { location } = useRouter();

  const params = useSchoolYearParams();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    search: queryString.parse(location.search),
    PAGE_SIZE,
    network: params.network,
    schoolStart: params.schoolStart,
    schoolEnd: params.schoolEnd
  });

  return (
    <ParentLayout
      location={location}
      extra={{
        schoolStart: params.schoolStart,
        schoolEnd: params.schoolEnd,
        variant: 'pending'
      }}
      breadcrumbs={['Evaluations', 'Events: Partners']}
      title="Pending Evaluations"
      description={(
        <span>
          Event evaluations sent to a partner, but not completed.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function(evaluationEventPartner) {
        return (
          <Evaluation
            key={evaluationEventPartner.id}
            evaluation={evaluationEventPartner}
          />
        );
      }}
    />
  );
}
